import styled, { css } from 'styled-components';
import { HashLink as RouterLink } from 'react-router-hash-link';

import { Media } from 'assets/Mixins.style';

export const Wrapper = styled.div`
  display: block;
  margin: ${props => props.theme.margin.default};

  ${Media.md`
    margin: ${props => props.theme.margin.md};
  `}
`;
export const Box = styled.div`
  display: grid;
  grid-template-columns: ${props => props.theme.gridTemplateColumns.default};
  gap: ${props => props.theme.gridGap.default};
  ${Media.md`
    grid-template-columns: ${props => props.theme.gridTemplateColumns.md};
    gap: ${props => props.theme.gridGap.md};

  `}
`;
export const Item = styled(RouterLink)`
  position: relative;
  display: grid;
  align-items: ${props => props.theme.alignItems || 'center'};
  word-break: break-word;
  grid-template-columns: ${props =>
    props.theme.gridTemplateColumns || '90px 1fr'};
  grid-gap: ${props => props.theme.gridGap.default};
  min-height: ${props => props.theme.minHeight.default};
  margin: ${props => props.theme.margin.default};
  padding: ${props => props.theme.padding.default};
  background: ${props => props.theme.background};
  border-radius: ${props => props.theme.borderRadius.default};
  border: ${props => props.theme.border};
  box-shadow: ${props => props.theme.boxShadow};
  transition: 0.2s all;
  cursor: pointer;
  overflow: hidden;
  ${Media.md`
    padding: ${props => props.theme.padding.md};
  `}
  &:hover {
    box-shadow: ${props => props.theme.boxShadowOnHover};
    text-decoration: ${props => props.theme.textDecorationOnHover || 'none'};
  }
  ${props =>
    props.withoutHover &&
    css`
      cursor: default;
      &:hover {
        box-shadow: ${props => props.theme.boxShadow};
        text-decoration: ${props =>
          props.theme.textDecorationOnHover || 'none'};
      }
    `}
`;

export const ItemExternal = styled.a`
  position: relative;
  display: grid;
  align-items: ${props => props.theme.alignItems || 'center'};
  word-break: break-word;
  grid-template-columns: ${props =>
    props.theme.gridTemplateColumns || '90px 1fr'};
  grid-gap: ${props => props.theme.gridGap.default};
  min-height: ${props => props.theme.minHeight.default};
  margin: ${props => props.theme.margin.default};
  padding: ${props => props.theme.padding.default};
  background: ${props => props.theme.background};
  border-radius: ${props => props.theme.borderRadius.default};
  border: ${props => props.theme.border};
  box-shadow: ${props => props.theme.boxShadow};
  transition: 0.2s all;
  cursor: pointer;
  overflow: hidden;
  ${Media.md`
    padding: ${props => props.theme.padding.md};
  `}
  &:hover {
    box-shadow: ${props =>
      props.theme.boxShadowOnHover || props.theme.boxShadow};
    text-decoration: ${props => props.theme.textDecorationOnHover || 'none'};
  }
`;

export const Imagebox = styled.div`
  display: ${props => props.theme.display || 'block'};
  width: ${props => props.theme.width || '90px'};
  height: ${props => props.theme.height || '90px'};
  margin: ${props => props.theme.margin.default};

  ${Media.md`
    margin: ${props => props.theme.margin.md};
  `}
`;

export const Image = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: ${props => props.theme.borderRadius.default};

  ${Media.md`
    border-radius: ${props => props.theme.borderRadius.md};
  `}
`;

export const Text = styled.h3`
  display: block;
  color: ${props => props.theme.color};
  transition: 0.2s all;
  font-family: ${props => props.theme.fontFamily};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  line-height: ${props => props.theme.lineHeight};
  font-weight: ${props => props.theme.fontWeight};

  ${Media.lg`
    font-size: ${props => `${props.theme.fontSize.lg}rem`};
  `}

  ${Media.md`
    font-size: ${props => `${props.theme.fontSize.md}rem`};
  `}

  ${Media.sm`
    font-size: ${props => `${props.theme.fontSize.sm}rem`};
  `}
`;
